import { useId, useState } from 'react';

import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

/** What the person said, as one line that opens to all of it when it is long */
export const HivemindIncomingQuote = ({ text }: { readonly text: string }) => {
  const [open, setOpen] = useState(false);
  const textId = useId();
  const flat = text.replace(/\s+/g, ' ').trim();
  const long = flat.length > 90 || text.includes('\n');
  return (
    <button
      type="button"
      disabled={!long}
      aria-expanded={long ? open : undefined}
      aria-label="What they said"
      aria-describedby={textId}
      className="flex items-start gap-1.5 border-l-2 border-foreground-muted pl-2 text-left text-sm text-foreground-subtle focus-ring disabled:cursor-default"
      onClick={() => setOpen(!open)}
    >
      <span
        id={textId}
        className={cn(
          'min-w-0 flex-1',
          open ? 'whitespace-pre-line' : long ? 'truncate' : 'break-words'
        )}
      >
        {open ? text : flat}
      </span>
      {long && (
        <Icons.chevronDown
          className={cn('mt-0.5 size-4 shrink-0', open && 'rotate-180')}
        />
      )}
    </button>
  );
};
